export enum Marketplace {
  SHOPIFY = 'SHOPIFY',
  AMAZON = 'AMAZON',
}
